<template>
  <section v-if="contact_faqs && contact_faqs.length > 0" class="py-10 container relative z-10 overflow-hidden">
    <div class="mb-12 flex justify-between gap-10">
      <GlobalHeading
          data-aos="fade-right"
          data-aos-once="true"
          :title="'FAQs'"
          opt-key-title="mobileAppPage.titleFAQs"
          class="flex-1"
      ></GlobalHeading>
      <div style="padding-top: 15px" data-aos="fade-left" data-aos-once="true">
        <nuxt-link
            :to="t('FAQ_INDEX_URL')"
            class="text-accent-01 text-sm leading-5 uppercase font-semibold hover:text-primary duration-200 hidden lg:flex items-end"
        >
          <span> {{ t('SHOW_MORE') }}</span>
          <span class="w-4.5 h-4.5 i-custom-chevron-right"></span>
        </nuxt-link>
      </div>
    </div>
    <!-- <div class="flex justify-between hover:text-opacity-80 text-accent-01 mb-7">
        <GlobalHeading :title="'FAQs'" opt-key-title="mobileAppPage.titleFAQs"></GlobalHeading>
        <nuxt-link
            :to="t('FAQ_INDEX_URL')"
            class="uppercase text-sm font-semibold leading-5 flex items-center gap-2 h-full"
        >
            <span>{{ t('VIEW_ALL') }}</span>
            <span class="i-ic:baseline-arrow-forward-ios text-xs transform duration-200"></span>
        </nuxt-link>
    </div> -->
    <div class="flex flex-col">
      <div data-aos="fade-right" data-aos-delay="200" data-aos-once="true"></div>
      <div class="flex lg:flex-row flex-col gap-8">
        <div data-aos="fade-left" data-aos-delay="300" data-aos-once="true" class="w-full lg:w-1/2">
          <img
              :src="getThumbnail(contact_faqs_image?.id, 800)"
              :alt="contact_faqs_image?.title"
              class="w-full aspect-2/1 lg:aspect-1/1 rounded-15px object-cover"
          />
        </div>
        <div class="gap-5 accordion flex flex-col lg:w-1/2 w-full justify-center">
          <GlobalBoxFAQs
              data-aos="fade-up"
              data-aos-once="true"
              @click="removeAttribute"
              class="removeAnimationFeature"
              v-for="(item, index) in contact_faqs"
              :index="index + 1"
              :key="item?.id"
              :data="item"
          ></GlobalBoxFAQs>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const {t} = useI18n()
const {getFaqSettings} = useAppGlobalData()
const dataRender = await getFaqSettings(useRoute().params.langCode)
const contact_faqs = dataRender?.contact_faqs
const contact_faqs_image = dataRender?.contact_faqs_image

const removeAttribute = () => {
  document.querySelectorAll('.removeAnimationFeature').forEach((item) => {
    item.removeAttribute('data-aos')
  })
}
</script>

<style>
.remove-mb > div {
  @apply !mb-0;
}
</style>
